import { AmountItem } from "@components/ui-kit/AmountItem";
import { currency } from "@src/utils/formatters";
import type React from "react";
import { useInvoiceDetailStore } from "../../store";

export const PrepaymentList = () => {
  const store = useInvoiceDetailStore();

  const brandCreditAccounts =
    store.invoice?.brands.flatMap((brand) => brand.creditAccounts || []) ?? [];

  const brandCreditAccountTitle = (id: string): React.ReactNode =>
    brandCreditAccounts.find((bca) => bca.id === id)?.title || null;

  return (
    <div className="space-y-2">
      {store.invoice?.prepaymentSplits?.map((split) => (
        <AmountItem
          key={split.brand_credit_account_id}
          description={brandCreditAccountTitle(split.brand_credit_account_id)}
        >
          {currency.formatByWorkspace(split.amount)}
        </AmountItem>
      ))}
    </div>
  );
};
